import React from 'react';
import { Breadcrumb } from 'antd';

import ALink from '@/components/ALink';

import { BreadcrumbType } from '@/@types/router';

export interface BreadCrumbsProps {
  list?: BreadcrumbType[];
  className?: string;
  /** 是否可点击跳转，默认 true；设为 false 仅展示不跳转 */
  clickable?: boolean;
}

const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ list = [], clickable = true, ...attr }) => (
  <Breadcrumb {...attr}>
    {list.map((item) => (
      <Breadcrumb.Item key={item.path}>
        {clickable ? <ALink to={item.path}>{item.title}</ALink> : <span>{item.title}</span>}
      </Breadcrumb.Item>
    ))}
  </Breadcrumb>
);

export default BreadCrumbs;
